<template>
  <div class="notes">
    <h3>Notes</h3>
    <div v-if="isLoading">
      <v-skeleton-loader
        type="list-item-avatar-three-line"
        v-for="(notes, index) in skeletonNotes"
        :key="index"
      />
    </div>
    <div v-else>
      <div>
        <div v-for="(notes, index) in notesByDate" :key="index">
          <p class="date">
            {{ notes[0].createdAt | timeForHumans }}
          </p>
          <Note
            v-for="(note, index) in notes"
            :isSelf="isSelf(note.author.id)"
            :author="note.author"
            :text="note.body"
            :attachments="note.attachments"
            :key="index"
          />
        </div>
      </div>
    </div>
    <template v-if="!readOnly && showNoteForm">
      <v-text-field
        aria-label="Add note"
        :disabled="isAdding || isLoading"
        :loading="isAdding"
        v-model="newNote"
        class="new-note"
        color="primary"
        placeholder="Add Note..."
        append-icon="mdi-arrow-up-circle"
        @click:append="addNote"
        @keydown.enter="addNote"
      />
      <FileUpload
        v-if="withAttachments"
        class="mt-2"
        @unselectFile="unselectFile"
        @selectFile="selectFile"
        :files="files"
        :fileTypes="['application/pdf']"
        disableAutoProceed
        customActions
        isMultiple
      />
    </template>

    <PrimaryButton
      v-if="!showNoteForm"
      text
      @click.native="showNoteForm = true"
    >
      Add Note +
    </PrimaryButton>
  </div>
</template>

<script>
import { getTimeForHumans, groupByDate } from "@/utils/helpers";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Note from "@/components/common/Notes/Note";
import FileUpload from "@/components/common/FileUpload";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  props: {
    notes: {
      type: Array,
      required: false,
      default: null
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false
    },
    isAdding: {
      type: Boolean,
      required: false
    },
    files: {
      type: Array,
      required: false
    },
    withAttachments: Boolean
  },
  components: {
    PrimaryButton,
    Note,
    FileUpload
  },
  data() {
    return {
      newNote: null,
      skeletonNotes: new Array(2).fill().map((a, i) => i),
      showNoteForm: false,
      uppyInstance: null
    };
  },
  computed: {
    ...mapState({
      self: state => state.userData
    }),
    notesByDate() {
      return groupByDate({ items: this.notes });
    }
  },
  methods: {
    isSelf(id) {
      return this.self.id === id;
    },
    addNote() {
      if (this.newNote) {
        this.$emit("note", this.newNote);
      }
    },
    selectFile({ uppyInstance, file }) {
      this.uppyInstance = uppyInstance;
      this.$emit("selectFile", file);
    },
    unselectFile({ file }) {
      this.$emit("unselectFile", file);
      this.resetFileInput();
    },
    resetFileInput() {
      if (this.uppyInstance) {
        this.uppyInstance.reset();
      }
    }
  },
  filters: {
    timeForHumans(date) {
      return getTimeForHumans(date);
    }
  },
  watch: {
    isAdding(newValue) {
      if (!newValue) {
        this.newNote = null;
      }
    }
  }
};
</script>

<style lang="scss">
.notes {
  margin-bottom: 20px;

  .base-button {
    padding: 0 5px !important;
  }
  .date {
    margin: 5px 0 5px !important;
    width: 100%;
    text-align: left;
    color: $secondary-text;
  }
  .v-input.v-text-field.new-note {
    width: 100%;
    background: #fff;
    padding: 5px 2px;
    margin-top: 0px;
  }
}
</style>
